export enum ForgotPasswordFormControls {
  EMAIL = 'email',
}
